import React from 'react';

import {
	howWillIKnowWhenItsTime,
	painAndAnxiety,
	qualityOfLife,
	qualityOfLifeScale,
	waitingTooLong,
	weighYourOptionsCarefully,
	whatAboutANaturalDeath,
} from '@app/components/Pages/HowWillIKnowItsTime/howWillIKnowItsTimeContent';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import drMaryLilu from '@app/images/content/dr-mary-lilu.jpg';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';

const HowWillIKnowItsTime: React.FC = () => {
	React.useEffect(() => {
		try {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		} catch (error) {
			window.scrollTo(0, 0);
			document.querySelector('#react-app')?.scrollTo(0, 0);
		}
	}, []);

	return (
		<HelmetProvider showLapOfLoveTitle={false}>
			<div className="angel-fund">
				<Masthead
					title="How Will I Know It’s Time to Say Goodbye?"
					imageSrc={drMaryLilu}
					imageAlt="How will I know it’s time for euthanasia"
				/>
				<RichText title="Assessing your pet's quality of life" text={howWillIKnowWhenItsTime} />
				<VideoEmbed text={qualityOfLifeScale} />
				<RichText title="Quality of life" text={qualityOfLife} />
				<VideoEmbed
					text={
						<>
							Are you having trouble assessing your pet’s quality of life?
							<br />
							Watch this video from Dr. Mary Gardner for help.
						</>
					}
					videoSrc="https://www.youtube.com/embed/hHOvvp-GtFA?si=pv1p2DD_ZwKKmQ1H"
				/>
				<RichText title="Pain and anxiety" text={painAndAnxiety} />
				<RichText title="Waiting too long" text={waitingTooLong} />
				<RichText title="What about a natural death?" text={whatAboutANaturalDeath} />
				<RichText title="Weigh your options carefully" text={weighYourOptionsCarefully} />
				<VideoEmbed
					text="Dr. Dani McVety’s video can answer many questions you may have about your pet’s end of life experience."
					videoSrc="https://www.youtube.com/embed/NRgCGQSYZV0?showinfo=0"
				/>
			</div>
		</HelmetProvider>
	);
};

export default HowWillIKnowItsTime;
